<template>
    <div class="relative overflow-hidden bg-white" id="calltoaction">
        <div class="my-12">
            <div
                class="max-w-76 mobile-lg:max-w-xs mobile-xl:max-w-lg tablet-sm:max-w-2xl tablet-lg:max-w-4xl laptop-lg:max-w-6xl desktop:max-w-7xl mx-auto"
            >
                <div class="flex justify-between items-start w-full flex-wrap tablet-sm:flex-nowrap">
                    <div
                        v-for="(form, index) in forms"
                        :key="index"
                        class="transition-all duration-500 ease-in-out bg-white w-full"
                        :class="[activeForm === index ? 'tablet-sm:w-11/12' : 'tablet-sm:w-1/3']"
                    >
                        <div
                            :class="[
                                'border-primary-bg border group transition-colors duration-500 mx-1 overflow-hidden',
                                activeForm === index
                                    ? 'bg-white border-secondary-bg'
                                    : 'bg-secondary-bg hover:bg-white hover:border-secondary-bg',
                            ]"
                        >
                            <button
                                :id="['cta_buying_button', 'cta_inquiry_button', 'cta_selling_button'][index]"
                                @click="toggleForm(index)"
                                class="w-full text-center block p-8"
                                :class="activeForm === index ?
                                'border-b border-secondary-accent tablet-sm:border-b-0' : '' ">
                                <h5
                                    :class="[
                                        'text-3xl font-title transition-colors duration-500',
                                        activeForm === index
                                            ? 'text-secondary-bg'
                                            :
                                            'text-white group-hover:text-secondary-bg',
                                    ]"
                                >
                                    {{ form.title }}
                                </h5>
                            </button>
                            <div
                                v-if="activeForm === index"
                                class="overflow-hidden transition-all duration-500 ease-in-out"
                                :style="{ maxHeight: showForm ? '1500px' : '0' }"
                            >
                                <div class="px-2 tablet-lg:px-4 laptop-sm:px-8 pb-8 pt-2">
                                    <form @submit.prevent="submitVelocityForm" id="velocity-submission-form-shared">
                                        <div class="flex justify-end">
                                            <div class="absolute">
                                                <button
                                                    @click="closeForm"
                                                    type="button"
                                                    class="bg-white border-accent border-2 hover:bg-accent
                                                    hover:text-white px-4 py-2 rounded absolute
                                                    -top-20 right-4
                                                    hidden tablet-sm:flex"
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                        <!-- Buying Form -->


                                        <div v-if="index === 0">
                                            <VelocityFormAnimation ref="buyingFormAnimation"
                                                                   :paperTitle="'Buyer Form'">
                                                <div id="cta_buying_form">
                                                    <FieldGroup>
                                                        <h2
                                                            class="text-base font-subtitle tablet-lg:text-lg mt-0 pt-0 text-lg font-semibold text-center"
                                                        >
                                                            Let's chat about your dream space! Share your vision, and I'll reach
                                                            out with some cozy ideas.
                                                        </h2>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="buyingForm.firstname"
                                                                :label="'First Name'"
                                                                :type="`text`"
                                                                required
                                                            />
                                                        </div>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="buyingForm.lastname"
                                                                :label="'Last Name'"
                                                                :type="`text`"
                                                                required
                                                            />
                                                        </div>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="buyingForm.email"
                                                                :label="'Email'"
                                                                :type="`email`"
                                                                required
                                                            />
                                                        </div>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="buyingForm.phone"
                                                                :label="'Phone (optional)'"
                                                                :type="`tel`"
                                                            />
                                                        </div>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <Radio
                                                            v-model="buyingForm.priceBreakpoint"
                                                            type="text"
                                                            label="Price Range"
                                                            required
                                                            :label="'Price Range'"
                                                            :options="[
                                                        { value: '100-300k', label: '$100,000-$300,000' },
                                                        { value: '300-500k', label: '$300,000-$500,000' },
                                                        { value: '500k+', label: '$500,000+' },
                                                    ]"
                                                            :name="'priceBreakpoint'"
                                                        />
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <Radio
                                                            v-model="buyingForm.timeFrame"
                                                            type="text"
                                                            label="Time Frame"
                                                            required
                                                            :label="'Price Range'"
                                                            :options="[
                                                        { value: '0-3months', label: '0 - 3 Months' },
                                                        { value: '3-6months', label: '3 - 6 Months' },
                                                        { value: '6-12months', label: '12+ Months' },
                                                    ]"
                                                            :name="'timeFrame'"
                                                        />
                                                    </FieldGroup>
                                                </div>
                                            </VelocityFormAnimation>


                                        </div>
                                        <!-- Inquiry Form -->
                                        <div v-if="index === 1">
                                            <VelocityFormAnimation ref="inquiryFormAnimation"
                                                                   :paperTitle="'New Inquiry'">
                                                <div id="cta_inquiry_form">
                                                    <FieldGroup>
                                                        <h2 class="mt-0 pt-0 font-subtitle text-lg font-semibold text-center">
                                                            Let's chat about your Florida real estate questions! Share what's on
                                                            your mind, and I'll reach out with helpful insights tailored just
                                                            for you.
                                                        </h2>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="inquiryForm.firstname"
                                                                :label="'First Name'"
                                                                :type="`text`"
                                                                required
                                                            />
                                                        </div>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="inquiryForm.lastname"
                                                                :label="'Last Name'"
                                                                :type="`text`"
                                                                required
                                                            />
                                                        </div>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="inquiryForm.email"
                                                                :label="'Email'"
                                                                :type="`email`"
                                                                required
                                                            />
                                                        </div>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="inquiryForm.phone"
                                                                :label="'Phone (optional)'"
                                                                :type="`tel`"
                                                            />
                                                        </div>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full">
                                                            <Input
                                                                v-model="inquiryForm.subject"
                                                                :label="'Subject'"
                                                                :type="`text`"
                                                                required
                                                            />
                                                        </div>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full">
                                                    <Textarea
                                                        v-model="inquiryForm.message"
                                                        :label="'Body'"
                                                        :type="`text`"
                                                        required
                                                    />
                                                        </div>
                                                    </FieldGroup>
                                                </div>
                                            </VelocityFormAnimation>
                                        </div>

                                        <!-- Selling Form -->
                                        <div v-if="index === 2">
                                            <VelocityFormAnimation ref="sellingFormAnimation"
                                                                   :paperTitle="'Seller Form'">
                                                <div id="cta_selling_form">
                                                    <FieldGroup>
                                                        <h2 class="mt-0 pt-0 font-subtitle text-lg font-semibold text-center">
                                                            Ready to pass your Florida keys to new dreamers? Share your home's
                                                            story, and I'll help showcase its appeal.
                                                        </h2>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="sellingForm.firstname"
                                                                :label="'First Name'"
                                                                :type="`text`"
                                                                required
                                                            />
                                                        </div>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="sellingForm.lastname"
                                                                :label="'Last Name'"
                                                                :type="`text`"
                                                                required
                                                            />
                                                        </div>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="sellingForm.email"
                                                                :label="'Email'"
                                                                :type="`email`"
                                                                required
                                                            />
                                                        </div>
                                                        <div class="w-full laptop-sm:w-1/2">
                                                            <Input
                                                                v-model="sellingForm.phone"
                                                                :label="'Phone (optional)'"
                                                                :type="`tel`"
                                                            />
                                                        </div>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <div class="w-full">
                                                            <Input
                                                                v-model="sellingForm.homeAddress"
                                                                :label="'Home Address'"
                                                                :type="`text`"
                                                                required
                                                                :placeholder="`Enter your address here`"
                                                            />
                                                        </div>
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <Radio
                                                            v-model="sellingForm.homeType"
                                                            type="text"
                                                            label="Home Type"
                                                            required
                                                            :label="'Home Type'"
                                                            :options="[
                                                        { value: 'single-family', label: 'Single-Family Home' },
                                                        { value: 'condo', label: 'Condominium' },
                                                        { value: 'townhouse', label: 'Townhouse' },
                                                        { value: 'multi-family', label: 'Multi-Family Home' },
                                                    ]"
                                                            :name="homeType"
                                                        />
                                                    </FieldGroup>

                                                    <FieldGroup>
                                                        <Radio
                                                            v-model="sellingForm.timeFrame"
                                                            type="text"
                                                            label="Time Frame"
                                                            required
                                                            :label="'Price Range'"
                                                            :options="[
                                                        { value: '0-3months', label: '0 - 3 Months' },
                                                        { value: '3-6months', label: '3 - 6 Months' },
                                                        { value: '6-12months', label: '12+ Months' },
                                                    ]"
                                                            :name="'timeFrame'"
                                                        />
                                                    </FieldGroup>
                                                </div>
                                            </VelocityFormAnimation>
                                        </div>

                                        <div class="mx-4 flex align-center">
                                            <Button>Submit</Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { route } from "ziggy-js";
import { ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import Input from "@velocity-forms/Input.vue";
import Radio from "@velocity-forms/Radio.vue";
import Button from "@velocity-forms/Button.vue";
import Textarea from "@velocity-forms/Textarea.vue";
import FieldGroup from "@velocity-forms/FieldGroup.vue";
import VelocityFormAnimation from "@/Components/Forms/VelocityFormAnimation.vue";

const forms = [{ title: "Buying" }, { title: "Inquiry" }, { title: "Selling" }];

const activeForm = ref(null);
const showForm = ref(false);

const buyingForm = useForm({
    firstname: "",
    lastname: "",
    email: "",
    priceBreakpoint: "", // radio button
    timeFrame: "", // dropdown
});

const inquiryForm = useForm({
    firstname: "",
    lastname: "",
    email: "",
    subject: "", // dropdown
    message: "",
});

const sellingForm = useForm({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    homeType: "", // dropdown
    timeFrame: "", // dropdown
    homeAddress: "",
});
const buyingFormAnimation = ref(null);
const inquiryFormAnimation = ref(null);
const sellingFormAnimation = ref(null);
const currentFormAnimation = ref(null);


const toggleForm = (index) => {
    if (activeForm.value === index) {
        closeForm();
    } else {
        activeForm.value = index;
        setTimeout(() => {
            showForm.value = true;
        }, 500);
    }
};

const closeForm = () => {
    showForm.value = false;
    activeForm.value = null;
};

const submitVelocityForm = async (e) => {
    e.preventDefault();

    // TODO remove do nothing line here, because its only for testing visuals.
    let currentForm;
    let formKey;

    if (activeForm.value === 0) {
        currentFormAnimation.value = buyingFormAnimation.value;
        currentForm = buyingForm;
        formKey = 'buying';
    } else if (activeForm.value === 1) {
        currentFormAnimation.value = inquiryFormAnimation.value;
        currentForm = inquiryForm;
        formKey = 'general_inquiry';
    } else if (activeForm.value === 2) {
        currentFormAnimation.value = sellingFormAnimation.value;
        currentForm = sellingForm;
        formKey = 'selling';
    }

    // Collect the submission data in a json string for insertion into submission table
    const jsonData = JSON.stringify(currentForm.data());
    // Now you want to set this jsonData into a new form's "value" field
    const velocitySubmissionForm = useForm({
        form_key: formKey,
        field_values: jsonData,
        redirect: "/#calltoaction",
        recaptcha_token: ''
    });


    try {
        // Execute reCAPTCHA
        velocitySubmissionForm.recaptcha_token  = await grecaptcha.enterprise.execute('6LeDhtAqAAAAAJm-0AUDswv8xmB2K8knAmdzyDHi', { action: 'SUBMIT' });
    } catch (error) {
        console.error('reCAPTCHA error:', error);
    }

    velocitySubmissionForm.post( route('velocitySubmission.submitPublic', velocitySubmissionForm.form_key ),{
        preserveState: true,
        preserveScroll: true,

        onError: (errors) => {
            // Log the detailed error object to the console for debugging
            // Construct a detailed error message if the errors object contains specific error messages
            let detailedErrorMessage = 'There was an error submitting the form.';
            if (errors && typeof errors === 'object' && Object.keys(errors).length > 0) {
                // Append each error message to the detailed error message
                Object.keys(errors).forEach((key) => {
                    detailedErrorMessage += ` ${key}: ${errors[key]}`;
                });
            }
            currentFormAnimation.value[0].toggleOnEnvelopeFailAnimation(detailedErrorMessage);

            // Display the detailed error message in the UI
            // page.props.messages.push({
            //     message: detailedErrorMessage,
            //     duration: 10,
            //     type: "error"
            // });
        },
        onSuccess: () => {
            currentFormAnimation.value[0].toggleOnEnvelopeSentAnimation();
            setTimeout(() => {
                closeForm();
                currentForm.reset();
            }, 7500)

        },
    });
}
</script>
